import React from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { BUSINESS_WHATSAPP_NUMBER } from '../helper/HelperUtils'

const WhatspButton = () => {
  return (
    <>
    <FloatingWhatsApp 
   phoneNumber={`+${BUSINESS_WHATSAPP_NUMBER}`} 
   accountName='Appscasa'
   avatar='/Appscasa.jpeg'
   chatMessage= {`Hi there !\nWelcome to Appscasa,\nWe are online and ready to help ?`}
   statusMessage ='Contact you within 5 minute'
   messageDelay={5}
   />
   </>
  )
}

export default WhatspButton
